module.exports = __webpack_public_path__ + "static/img/5j.2cd919d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5j.jpg
// module id = cInm
// module chunks = 0